import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { ICategoria } from "shared/interfaces/ICategoria";
import { buscarCategorias } from "shared/services/api/categoria.api";
import styles from "./Categorias.module.scss";

interface CategoriasProps {
  categorias?: ICategoria[];
  onCategoriaClick?: (categoria: ICategoria) => void;
  categoriaSelecionada?: ICategoria | null;
}

const imageMap: Record<string, string> = {
  "calcados-roupas-e-bolsas": "/imagens/categorias/roupas.png",
  "tv-video-e-eletronicos": "/imagens/categorias/eletronicos.png",
  eletrodomesticos: "/imagens/categorias/eletrodomesticos.png",
  construcao: "/imagens/categorias/construcao.png",
  casa: "/imagens/categorias/decoracoes.png",
  "brinquedos-e-hobbies": "/imagens/categorias/brinquedos.png",
  farmacia: "/imagens/categorias/farmacia.png",
  games: "/imagens/categorias/games.png",
  "agropecuarias-e-pet": "/imagens/categorias/agro.png",
  "beleza-e-cuidado-pessoal": "/imagens/categorias/cuidados.png",
  "antiguidades-e-colecoes": "/imagens/categorias/antiguidades.png",
  "joias-e-acessorios": "/imagens/categorias/joias.png",
  "moda-infantil": "/imagens/categorias/moda infantil.png",
  "cameras-e-acessorios": "/imagens/categorias/cameras.png",
  "celulares-e-acessorios": "/imagens/categorias/celulares.png",
  "arte-papelaria-e-armarinho": "/imagens/categorias/papelaria.png",
  "artigos-religiosos": "/imagens/categorias/artigosreligiosos.png",
  veiculos: "/imagens/categorias/veiculos.png",
  saude: "/imagens/categorias/saude.png",
  "esportes-e-fitness": "/imagens/categorias/fitness.png",
  outros: "/imagens/categorias/outros.png",
};

export const Categorias = ({
  categorias: categoriasRecebidas,
  onCategoriaClick,
  categoriaSelecionada,
}: CategoriasProps) => {
  const [categoriasApi, setCategorias] = useState<ICategoria[]>([]);
  const navigate = useNavigate();
  const usaListaRecebida = categoriasRecebidas !== undefined;
  const categorias = categoriasRecebidas ?? categoriasApi;

  useEffect(() => {
    if (usaListaRecebida) return;
    let ativo = true;
    async function fetchCategorias() {
      try {
        const dados = await buscarCategorias();
        if (ativo) setCategorias(dados);
      } catch (error) {
        console.error("Erro ao obter categorias:", error);
      }
    }
    fetchCategorias();
    return () => { ativo = false; };
  }, [usaListaRecebida]);

  const handleClickCategoria = (categoria: ICategoria) => {
    if (onCategoriaClick) onCategoriaClick(categoria);
    else navigate(`/categoria/${categoria.slug}`);
  };

  return (
    <div className={styles.categoriasWrapper}>
      <Swiper modules={[Navigation]} spaceBetween={10} grabCursor breakpoints={{
        0: { slidesPerView: 4 },
        480: { slidesPerView: 4 },
        768: { slidesPerView: 4 },
        1024: { slidesPerView: 5 },
        1400: { slidesPerView: 6 },
      }}>
        {categorias.map((categoria) => {
          const selecionada = categoriaSelecionada?.id === categoria.id;
          return (
            <SwiperSlide key={categoria.id}>
              <button type="button" className={`${styles.item} ${selecionada ? styles.itemSelecionado : ""}`} onClick={() => handleClickCategoria(categoria)} aria-pressed={selecionada}>
                <span className={`${styles.iconWrapper} ${selecionada ? styles.iconSelecionado : ""}`}>
                  <img src={imageMap[categoria.slug] ?? "/imagens/categorias/default.png"} alt="" className={styles.iconImage} />
                </span>
                <span className={`${styles.nomeIcon} ${selecionada ? styles.nomeSelecionado : ""}`}>{categoria.nome}</span>
              </button>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
